/* GinJu Supplies theme JS — FAQ折叠 / Before-After滑块 / 聊天窗 / 图库切换 / 加购反馈 */

document.addEventListener('DOMContentLoaded', function () {
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mainNav = document.getElementById('main-nav');
  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', function () {
      var open = mainNav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuToggle.classList.toggle('is-open', open);
    });
    mainNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        if (window.matchMedia('(max-width: 800px)').matches && link.closest('.has-dropdown')) return;
        mainNav.classList.remove('open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.classList.remove('is-open');
      });
    });
  }
  // 导航 Product 下拉：移动端点父项展开/收起子分类（桌面悬停展开，父链接仍直达集合页）
  document.querySelectorAll('.nav-links .has-dropdown').forEach(function (item) {
    var parentLink = item.querySelector(':scope > a');
    if (!parentLink) return;
    parentLink.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width: 800px)').matches) {
        e.preventDefault();
        item.classList.toggle('open');
      }
    });
  });
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchForm = document.getElementById('site-search');
  if (searchToggle && searchForm) {
    searchToggle.addEventListener('click', function () {
      var isOpen = !searchForm.hasAttribute('hidden');
      if (isOpen) { searchForm.setAttribute('hidden', ''); } else { searchForm.removeAttribute('hidden'); searchForm.querySelector('input').focus(); }
      searchToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }
  // 1. FAQ 折叠
  document.querySelectorAll('.faq-question').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = this.parentElement;
      var open = item.classList.toggle('open');
      this.setAttribute('aria-expanded', open);
    });
  });

  // 2. 首页问题/解决方案对比滑块（支持多个 Section 实例）
  document.querySelectorAll('[data-compare]').forEach(function (compare) {
    var after = compare.querySelector('[data-compare-after]');
    var line = compare.querySelector('[data-compare-line]');
    var handle = compare.querySelector('[data-compare-handle]');
    if (!after || !line || !handle) return;
    var dragging = false;
    function setPosition(event) {
      var rect = compare.getBoundingClientRect();
      var x = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
      var p = (x / rect.width) * 100;
      after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
      line.style.left = p + '%';
      handle.style.left = p + '%';
    }
    compare.addEventListener('pointerdown', function (e) {
      dragging = true;
      compare.setPointerCapture(e.pointerId);
      setPosition(e);
    });
    compare.addEventListener('pointermove', function (e) { if (dragging) setPosition(e); });
    compare.addEventListener('pointerup', function () { dragging = false; });
    compare.addEventListener('pointercancel', function () { dragging = false; });
    handle.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var current = parseFloat(handle.style.left || '50');
      var next = Math.max(5, Math.min(95, current + (e.key === 'ArrowRight' ? 5 : -5)));
      after.style.clipPath = 'inset(0 0 0 ' + next + '%)';
      line.style.left = next + '%';
      handle.style.left = next + '%';
    });
  });

  // 3. 聊天窗
  var toggle = document.getElementById('chatToggle');
  var box = document.getElementById('chatBox');
  if (toggle && box) {
    var close = document.getElementById('chatClose');
    function setChat(open) {
      box.classList.toggle('visible', open);
      toggle.setAttribute('aria-expanded', open);
    }
    toggle.addEventListener('click', function () { setChat(!box.classList.contains('visible')); });
    if (close) close.addEventListener('click', function () { setChat(false); });
  }

  // 4. 产品图库：轮播滑动 + 左上点导航 + 缩略图切换（详情页）
  var carousel = document.getElementById('mainCarousel');
  var dotsWrap = document.getElementById('carouselDots');
  var thumbs = document.querySelectorAll('.thumb');
  if (carousel && thumbs.length) {
    var slides = carousel.querySelectorAll('.carousel-slide');
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Image ' + (i + 1));
        d.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }
    function sync(i) {
      dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('selected', j === i); });
    }
    function go(i) {
      carousel.scrollTo({ left: i * carousel.clientWidth, behavior: 'smooth' });
      sync(i);
    }
    carousel.addEventListener('scroll', function () {
      sync(Math.round(carousel.scrollLeft / carousel.clientWidth));
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        go(parseInt(t.getAttribute('data-index'), 10) || 0);
      });
    });
  }

  // 4b. SHARE 分享（移动端优先系统分享，兜底复制链接）
  var shareBtn = document.getElementById('shareBtn');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var label = shareBtn.querySelector('.share-label');
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          if (label) label.textContent = 'LINK COPIED';
          setTimeout(function () { if (label) label.textContent = 'SHARE'; }, 1800);
        });
      }
    });
  }

  // 5. 套餐选择高亮（详情页）
  document.querySelectorAll('.bundle').forEach(function (label) {
    label.addEventListener('click', function () {
      document.querySelectorAll('.bundle').forEach(function (b) { b.classList.remove('selected'); });
      label.classList.add('selected');
    });
  });

  // 6. 加购反馈（非 Shopify form 兜底；标准 form 走 Shopify 原生）
  var addBtn = document.getElementById('addCart');
  var cartMsg = document.getElementById('cartMessage');
  if (addBtn && cartMsg && !addBtn.closest('form')) {
    addBtn.addEventListener('click', function () {
      cartMsg.textContent = 'Added to cart';
      var count = document.querySelector('.cart-count');
      if (count) count.textContent = parseInt(count.textContent || '0', 10) + 1;
    });
  }

  // 7. 首页评价轮播：每个 Section 独立工作
  document.querySelectorAll('[data-reviews-track]').forEach(function (reviewTrack) {
    var sliderWrap = reviewTrack.parentElement;
    var reviewPrev = sliderWrap ? sliderWrap.querySelector('.reviews-prev') : null;
    var reviewNext = sliderWrap ? sliderWrap.querySelector('.reviews-next') : null;
    function reviewStep() {
      var card = reviewTrack.querySelector('.review');
      if (!card) return 0;
      var gap = parseFloat(window.getComputedStyle(reviewTrack).columnGap || '0');
      return card.getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
    }
    function updateReviewButtons() {
      var max = reviewTrack.scrollWidth - reviewTrack.clientWidth;
      if (reviewPrev) reviewPrev.disabled = reviewTrack.scrollLeft <= 2;
      if (reviewNext) reviewNext.disabled = reviewTrack.scrollLeft >= max - 2;
    }
    if (reviewPrev) reviewPrev.addEventListener('click', function () { reviewTrack.scrollBy({ left: -reviewStep(), behavior: 'smooth' }); });
    if (reviewNext) reviewNext.addEventListener('click', function () { reviewTrack.scrollBy({ left: reviewStep(), behavior: 'smooth' }); });
    reviewTrack.addEventListener('scroll', updateReviewButtons, { passive: true });
    updateReviewButtons();
    var reviewDragging = false, reviewStartX = 0, reviewStartLeft = 0;
    reviewTrack.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      reviewDragging = true;
      reviewStartX = e.clientX;
      reviewStartLeft = reviewTrack.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!reviewDragging) return;
      reviewTrack.scrollLeft = reviewStartLeft - (e.clientX - reviewStartX);
    });
    window.addEventListener('pointerup', function () { reviewDragging = false; });
    window.addEventListener('pointercancel', function () { reviewDragging = false; });
  });
});
